import { useQuery } from "@tanstack/react-query"

import { client } from "@/api"
import queryKeys from "@/api/queryKeys"

function useGetCalendarEvents({
  filters,
}: {
  filters: {
    type: string
    year: number
    month: number
    searchValue: string
    filterValue: string[]
    ageRange: string
    petFriendly: string
    price: string
  }
}) {
  return useQuery({
    queryKey: queryKeys.events.calendarPage({}).queryKey,
    queryFn: () =>
      client
        .get(`/events`, { params: { ...filters } })
        .then((response) => response.data),
  })
}
export default useGetCalendarEvents
